import { observable } from 'mobx';

/**
 * Where the payment section wants the checkout's place order button, if anywhere.
 */
export interface IGhPlaceOrderSlot {
    element: HTMLElement;
    amountDue: number;
}

/**
 * Set by the payment section container, read by the checkout module, which portals its place order
 * button into the element. Empty means the button stays in its default place.
 */
export const placeOrderSlot = observable.box<IGhPlaceOrderSlot | undefined>(undefined, { deep: false });
